
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Shri Vyankateshay Namaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Shri Vyankateshay Namaa" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Venkatesh Stotra, Venkatesh Stotra lyrics, Venkatesh Stotra lyrics marathi, Venkatesh Stotra lyrics english, venkatesha, vyankatesh stotra, व्यंकटेश स्तोत्र, shree vyankatesh stotra, shri vyankatesh stotra, श्री व्यंकटेश स्तोत्र, वेंकटेश स्त्रोत, vyanktesh stotra, व्यकटेश स्तोत्र, vyankatesh strotra, vyankatesh stotra lyrics, व्यंकटेश'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Venkatesh Stotra, Venkatesh Stotra lyrics, Venkatesh Stotra lyrics marathi, व्यंकटेश स्तोत्र, श्री व्यंकटेश स्तोत्र मराठी, shri venkatesha namah shri vyankatesh stotra lyrics, shree vyankatesh stotra, श्री व्यंकटेश स्तोत्र, वेंकटेश स्त्रोत, vyanktesh stotra, व्यकटेश स्तोत्र, vyankatesh strotra, vyankatesh stotra lyrics, व्यंकटेश' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/vyankatesh.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/vyankatesh.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shri Vyankateshay Namaa | Shri Vyankatesh Stotra - श्री व्यंकटेशाय नमः(श्री व्यंकटेश स्तोत्र)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/vyankatesh"
        },
        "headline": "Shri Vyankateshay Namaa - श्री व्यंकटेशाय नमः(श्री व्यंकटेश स्तोत्र)",
        "name" : "Shri Vyankateshay Namaa - Shri Vyankatesh Stotra",
        "description": "Explore the full lyrics of stotra 'Shri Vyankateshay Namaa' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/vyankatesh.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2025-08-05T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  